export const formatPassport = (value: string): string => {
    const digits = value.replace(/\D/g, '');
    let result = '';
    if (digits.length > 0) {
        result += digits.substring(0, 2);
    }
    if (digits.length > 2) {
        result += ` ${digits.substring(2, 4)}`;
    }
    if (digits.length > 4) {
        result += ` ${digits.substring(4, 10)}`;
    }

    return result;
};

export const formatSnils = (value: string): string => {
    const digits = value.replace(/\D/g, '');
    let result = '';
    if (digits.length > 0) {
        result += digits.substring(0, 3);
    }
    if (digits.length > 3) {
        result += ` ${digits.substring(3, 6)}`;
    }
    if (digits.length > 6) {
        result += ` ${digits.substring(6, 9)}`;
    }
    if (digits.length > 9) {
        result += ` ${digits.substring(9, 11)}`;
    }

    return result;
};

export const formatSubdivisionCode = (value: string): string => {
    const digits = value.replace(/\D/g, '');

    return digits.substring(0, 6);
};

export const formatBik = (value: string): string => {
    const digits = value.replace(/\D/g, '');

    return digits.substring(0, 9);
};

export const formatAccountNumber = (value: string): string => {
    const digits = value.replace(/\D/g, '');

    return digits
        .substring(0, 20)
        .replace(/(.{4})/g, '$1 ')
        .trim();
};

export const formatIndex = (value: string): string => {
    const digits = value.replace(/\D/g, '');

    return digits.substring(0, 6);
};

export const formatInnOgrn = (value: string): string => {
    const digits = value.replace(/\D/g, '');

    return digits.substring(0, 15);
};

export const formatLettersOnly = (value: string): string =>
    value.replace(/[^a-zA-Zа-яА-Я\s-]/g, '');
